
import React, { useEffect } from "react";
import { Spinner } from "@sapphire-react/lab";
import * as styles from './PostLogonComponent.style';
import { useNavigate , useParams , useLocation } from 'react-router-dom';
import { PostLegacyLogin } from "../../api/ApiCalls";
import { Variables } from "../../api/utils/endpoints";

const PostLogonComponent = () => {
    //getting the language paramter in the url
    var { language } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const allowedLanguages = Variables.allowedLanguageArray;
    const defaultLanguage = Variables.finnishLanguageCode;

    //fetching the ticketID from the query parameter
    const searchParams = new URLSearchParams(location.search);
    const ticketID = searchParams.get(Variables.TicketIDQueryParameter);
    useEffect(() => {
        //If no ticketID is provided, go to the Error screen
        if (!ticketID) {
            console.log("No TicketID provided in the query");
            navigate(`/${language}/logon/error`, { replace: true })
            return;
        }
        //If no language or any other language is given, go to the default language
        if (!language || !allowedLanguages.includes(language)) {
            navigate(`/${defaultLanguage}/logon${location.search}`, { replace: true });
            return;
        }
        else {
            //Call /legacy-login endpoint
            const CallLeacyLogin = async (language: string, TicketID: string) => {
                try {
                    await PostLegacyLogin(language, TicketID);
                }
                catch(error) {
                    navigate(`/${language}/logon/error`, { replace: true })
                    return;
                }
            };
            CallLeacyLogin(language as string, ticketID);
        }
    }, [ticketID, language, navigate, location.search, allowedLanguages, defaultLanguage]);

    return (
        <div style={styles.mainDiv}>
            <Spinner aria-label="Loading..." size="xl" margin="auto" />
        </div>
    );
};

export default PostLogonComponent;